<template>
  <main class="dashboard assistance">
    <div class="container-fluid container-fluid--max">
      <notification></notification>
      <div class="card">
        <div class="dash-assist card-body d-flex px-lg-5" :class="'dashboard__content' + (supportRequests.length ? '' : '--empty')">
          <h1 class="dashboard__title heading-secondary mb-0">Mes demandes d'assistance</h1>
          <moon-loader :loading="loadingRequest" color="#dc3545" size="30px" class="ml-4"></moon-loader>
          <section class="my-4" v-if="supportRequests.length">
            <c-card
              v-for="sr in supportRequests"
              :key="sr.id"
              :item="sr"
              :id="'support_request' + sr.id"
              :class="{ 'ope-card--closed': sr.closed }">
              <template v-slot:header>
                <div class="dash-assist__main col-auto">
                  <p>
                    <span class="badge badge-primary font-size-normal mb-1 mr-2">#{{ sr.id }}</span>
                    <span class="badge font-size-normal" :class="`badge-${sr.status.badge}`">{{ sr.status.title }}</span>
                  </p>
                  <p class="mb-0">Créée pour <span class="h5 thin">{{ sr.product.name }}
                  <small v-if="sr.product.type" class="bg-dark text-white px-2">
                    {{ sr.product.type }}
                  </small></span></p>
                  <p class="text-secondary thin mb-0">le {{ sr.created_at }}</p>
                </div>
              </template>
              <template v-slot:button v-if="sr.no_review && sr.kind === 'bestove'">
                <router-link
                  v-if="sr.closed"
                  :to="{ name: 'supportRequestReview', params: { id: sr.id }}"
                  class="dashboard__details-btn btn thin mb-2 mb-md-0 mr-md-3"
                  :class="'btn-outline-' + $mainColor"
                  @click.native="$scrollToTop">
                  Noter cette intervention
                </router-link>
              </template>
              <template v-slot:button v-else>
                <span class="rating-display rating-display--5stars mr-4" v-if="sr.kind === 'bestove'">
                  <span class="rating-display__rating rating-display--5stars__rating" :style="'width:' + sr.rating * 20 +'%;'"></span>
                </span>
              </template>
              <div slot="body" class="row">
                <div class="dash-prdts__details-col col-12" :class="{ 'col-md-7 col-lg-8': sr.images.length }">
                  <h3 class="heading-secondary">Description du problème</h3>
                  <div class="text-info mt-3">
                    {{ sr.problem_description }}
                  </div>
                </div>
                <div class="dash-prdts__details-col col-12 col-sm-8 col-md-5 col-lg-4 mt-3 mt-md-0" v-if="sr.images.length">
                  <h3 class="heading-secondary">Photos du problème</h3>
                  <div class="grid1x1 mt-3">
                    <div class="grid1x1__item--3x" v-for="(img, i) in sr.images" :key="'sr-img-' + i">
                      <div class="grid1x1__item-inner">
                        <img class="grid1x1__img" :alt="img.filename" :src="img.url" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </c-card>
          </section>
          <router-link
            :to="{ name: 'supportRequestForm' }"
            class="dashboard__btn btn align-self-end ml-auto"
            :class="'btn-outline-' + $mainColor"
            @click.native="$scrollToTop">
            Nouvelle demande d'assistance
          </router-link>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import MoonLoader from 'vue-spinner/src/MoonLoader.vue'
import { mapState, mapGetters } from 'vuex'
import { scrollAnchor } from '@/utils/helpers'
import store from '@/store'

export default {
  name: 'SupportRequests',
  components: {
    MoonLoader
  },
  computed: {
    ...mapState(['loadingRequest']),
    ...mapGetters({ supportRequests: `${store.$appName}/supportRequests` })
  },
  mounted () {
    scrollAnchor(this.$router)
    if (this.$route.params.notification) {
      this.$store.dispatch('setNotification', {
        message: this.$route.params.notification,
        mode: 'danger'
      })
    }
  }
}
</script>
